<template>
  <Line
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :style="myStyles"
  />
</template>

<script>
import { Line } from "vue-chartjs";
import moment from "moment";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
);

export default {
  name: "WellnessLineChart",
  components: { Line },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    chartId: {
      type: String,
      default: "wellness-line-chart",
    },
    metricType: {
      type: String,
      default: "sleep",
    },
  },
  computed: {
    myStyles() {
      return {
        height: "300px",
        width: "100%",
      };
    },
    chartOptions() {
      const labelMap = {
        // 1–5, the scale every client now rates on (see utils/wellnessScale.js)
        muscle_soreness: { 5: "None", 4: "Feeling ok", 3: "Some soreness", 2: "Sore muscles", 1: "Very sore" },
        fatigue: { 5: "None", 4: "Bit tired", 3: "Sluggish", 2: "Very tired", 1: "Exhausted" },
        stress: { 5: "Very good", 4: "Good", 3: "Ok", 2: "Bit stressed", 1: "Very stressed" },
        happyness: { 5: "Very happy", 4: "Happy", 3: "Feeling ok", 2: "Not so good", 1: "Unhappy" },
        sleep: { 5: "Amazing", 4: "Good", 3: "Ok", 2: "Not so good", 1: "Bad" },
      };

      const metric = this.metricType;

      return {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: "rgba(0,0,0,0.8)",
            titleFont: { size: 13 },
            bodyFont: { size: 13 },
            padding: 12,
            cornerRadius: 8,
            callbacks: {
              label: function (context) {
                const val = context.parsed.y;
                const label = labelMap[metric]?.[Math.round(val)] || "";
                return `${val}/5 — ${label}`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 11 },
              callback: function (value) {
                const label = this.getLabelForValue(value);
                return moment(label).format("DD MMM");
              },
            },
          },
          y: {
            min: 0,
            max: 6,
            ticks: {
              stepSize: 1,
              font: { size: 11 },
              callback: function (value) {
                return labelMap[metric]?.[value] || "";
              },
            },
            grid: {
              color: function (context) {
                // Highlight the "Ok" threshold line at 3
                if (context.tick.value === 3) {
                  return "rgba(255, 152, 0, 0.5)";
                }
                return "rgba(0,0,0,0.06)";
              },
              lineWidth: function (context) {
                if (context.tick.value === 3) {
                  return 2;
                }
                return 1;
              },
            },
          },
        },
        elements: {
          line: {
            tension: 0.35,
            borderWidth: 3,
          },
          point: {
            radius: 4,
            hoverRadius: 7,
            backgroundColor: "#fff",
            borderWidth: 2,
          },
        },
      };
    },
  },
};
</script>
